/* eslint-disable prefer-rest-params */
import $ from 'jquery';
import _ from 'underscore';
import '@bingads-webui/kendo/kendo.window';


let windowDefaults = {
  modal: true,
  maxWidth: 600,
  resizable: false,
  visible: false,
  title: '',
};

let decorate = function(View, dialogOptions) {
  function _applyIfExists(func, context, args) {
    if (_.isFunction(func)) {
      func.apply(context, _.toArray(args));
    }
  }
  class DecoratedView extends View {

    initialize(options) {
      this.options = options || {};
      this.destroy = this.remove;
      if (!_.has(View.prototype, 'render')) {
        this.show();
      }
      _applyIfExists(View.prototype.initialize, this, arguments);
    }

    render() {
      this.show();

      _applyIfExists(View.prototype.render, this, arguments);
      this.setPosition();

      return this;
    }

    setPosition() {
      if (this.dialogOptions.position === 'center') {
        this.center();
      }
    }

    show() {
      let options = _.defaults({
        title: this.options.title,
        autoFocus: true,
        animation: false,
      }, this.options.dialogOptions, dialogOptions, windowDefaults);

      if (!this._window) {
        this._window = this.$el
          .kendoWindow(options)
          .data('kendoWindow');
      }

      this._window.wrapper.attr('role', 'dialog');
      this._window.wrapper.attr('aria-label', options.title);
      if (options.rootId) {
        this._window.wrapper.attr('id', options.rootId);
      }
      this._window.center();
      this._window.open();

      let $closeIcon = $('span.k-icon.k-i-close', this._window.wrapper);

      $closeIcon.html('').click(_.bind(this.remove, this));

      _.each(options.dialogClasses, (className) => {
        this._window.element.addClass(className);
      }, this);

      if (options.zindex) {
        this.$el.css('z-index', options.zindex);
      }

      if (!_.isEmpty(options.popupFront)) {
        let element = $(options.popupFront);

        if (element && element.length > 0) {
          let topzindex = parseInt(element.css('z-index'), 10) + 2;
          let kwindow = $('.k-window');
          let koverlay = $('.k-overlay');

          if (kwindow && kwindow.length > 0) {
            kwindow.css('z-index', topzindex);
          }
          if (koverlay && koverlay.length > 0) {
            koverlay.css('z-index', topzindex - 1);
          }
        }
      }

      this.dialogOptions = options;

      return this;
    }

    center() {
      if (this._window) {
        this._window.center();
      }
      return this;
    }

    hide() {
      if (this._window) {
        this._window.close();
      }
      return this;
    }

    remove(e) {
      if (e) {
        e.preventDefault();
      }

      if (this._window) {
        _applyIfExists(View.prototype.remove, this, arguments);
        _applyIfExists(View.prototype.destroy, this, arguments);

        this._window.close();
        this._window.destroy();
        this._window = null;
      }
    }
  }

  return DecoratedView;
};

export {
  decorate,
};
